import React from 'react';
import { Preset, Tag } from '@lux/text';
import { FunctionColor, SupportingColor } from '@lux/core';
import { StyledText } from './styles';
const AssistiveText = ({ error, errorMessage, hint, className, id, }) => {
    if ((!error || !errorMessage) && !hint)
        return null;
    const role = error && errorMessage ? 'alert' : null;
    return (React.createElement(StyledText, { id: id, preset: Preset.XS, tag: Tag.P, color: error ? SupportingColor.alert : FunctionColor.function60, className: className, role: role }, (error && errorMessage) || hint));
};
export default AssistiveText;
//# sourceMappingURL=component.js.map